/**
 * Văn bản consent xác thực danh tính (TT 83 C1-c) — NĐ 13/2023: ảnh khuôn mặt là dữ liệu
 * sinh trắc học (DLCN nhạy cảm) → consent riêng, rõ mục đích + thời hạn + quyền rút.
 *
 * ĐỔI NỘI DUNG Ở ĐÂY → PHẢI tăng `IDENTITY_CONSENT_VERSION` (BE settings) cùng commit, để
 * người đã đồng ý bản cũ phải đồng ý lại. Thời hạn khớp `EKYC_DOCUMENT_RETENTION_DAYS` /
 * `EXAM_SELFIE_RETENTION_DAYS` trong `backend/sep2026/settings/base.py`.
 * CHƯA qua pháp chế duyệt — xem `docs/dev/2026-10-tt83-pii-compliance.md`.
 */
export const IDENTITY_CONSENT_POINTS: string[] = [
  "Mục đích: xác thực đúng người học khi nhập học và khi vào thi có giám sát, theo yêu cầu của Bộ GD&ĐT về đào tạo từ xa (Thông tư 56/2026, Thông tư 83/2026).",
  "Dữ liệu thu: ảnh 2 mặt căn cước công dân (hoặc hộ chiếu), ảnh khuôn mặt khi đăng ký, ảnh khuôn mặt mỗi lần vào thi. Ảnh khuôn mặt là dữ liệu cá nhân nhạy cảm.",
  "Thời hạn lưu: ảnh giấy tờ xoá sau 30 ngày; ảnh khuôn mặt khi vào thi xoá sau 90 ngày (trừ trường hợp đang xem xét nghi vấn); ảnh khuôn mặt đăng ký giữ để đối chiếu cho tới khi bạn rút đồng ý.",
  "Người được xem: quản trị viên của trường; giảng viên coi thi chỉ xem ảnh phiên thi môn mình phụ trách. Mỗi lần xem đều được ghi nhật ký.",
  "Ảnh có thể được gửi tới nhà cung cấp dịch vụ xác thực (lưu trữ tại Việt Nam) chỉ để so khớp khuôn mặt.",
  "Bạn có quyền rút đồng ý bất kỳ lúc nào tại trang này — toàn bộ ảnh sẽ bị xoá ngay. Khi đó bạn sẽ không vào được các bài thi bắt buộc xác thực cho tới khi xác thực lại.",
];
